export enum VisitMadeStatusEnum {
  UnderEvaluation = 50,
  Evaluated = 60,
}
